import { ReactNode, useLayoutEffect, useMemo } from "react"

import localStore, { useLocalStoreState } from "@/components/localStore"

import { ReportingYearContext } from "./context.ts"
import { years } from "./YearSwitch.tsx"

export default function ReportingYearProvider({ children }: { children: ReactNode }) {
  const [reportingYear, setReportingYear] = useLocalStoreState("reportingYear", {
    searchParamCallback: (yearFromSearchParams) => {
      //toast.info(`Reporting year was set to ${yearFromSearchParams} from the URL`) // TODO replace Toastify with something that actually works...
      alert(
        `Reporting year was set to ${yearFromSearchParams} from the URL\nTODO replace Toastify with something that actually works...`,
      )
    },
  })

  useLayoutEffect(
    () =>
      setReportingYear((prev) => {
        if (!years) return prev // if years not loaded
        if (prev != null && years.includes(prev)) return prev // if valid year is set

        const savedYear = localStore.getItem("reportingYear")
        if (savedYear != null && years.includes(savedYear)) return savedYear

        if (years.length) return years[0]
        return null
      }),
    [setReportingYear, years],
  )

  const contextValue = useMemo(() => ({ reportingYear, setReportingYear }), [reportingYear, setReportingYear])

  return <ReportingYearContext.Provider value={contextValue}>{children}</ReportingYearContext.Provider>
}
